module.exports = __webpack_public_path__ + "static/abbyhollonabbiewithmug-ece40a26d7ea4106cc1e2f5d9b3e18e7.jpg";